import React, {Component} from "react";
import {Link} from "react-router";
import applogic from "../applogic.js";
import ReactImageFallback from "react-image-fallback";

class ModuleVideoListItem extends Component {
    static compare(a, b) {
        let comp = +new Date(a.props.time) - +new Date(b.props.time);
        if (comp !== 0)
            return comp;
        let aname = a.props.name.toLowerCase();
        let bname = b.props.name.toLowerCase();
        if (/^[0-9]/.test(aname) && /^[0-9]/.test(bname)) {
            let aidx = parseFloat(aname);
            let bidx = parseFloat(bname);
            comp = aidx - bidx;
        }
        if (comp !== 0)
            return comp;
        return aname > bname ? 1 : aname < bname ? -1 : 0;
    }

    render() {
        let thumbnail = applogic.getThumbnailUrlOrPlaceholder(this.props);
        return (
            <div>
                <Link className="list-group-item list-group-item-action"
                      to={'/v/' + this.props.ID}>
                    <span>
                        {this.props.wname && this.props.wname + ' - '}{this.props.name}
                        <br />
                        Uploaded: {new Date(this.props.time).toUTCString().replace(/\s*(GMT|UTC)$/, "") || ''}
                        <br />
                        {this.props.views} Views |&nbsp;{this.props.comments || 0} Comments
                    </span>
                    <div className="list-item-thumbnail-wrapper"><ReactImageFallback
                        src={thumbnail}
                        fallbackImage="https://ivle.nus.edu.sg/images/video_thumb.jpg"
                        initialImage="/img/loader.gif"
                        alt=""
                        className="video-thumbnail" /></div>
                </Link>
            </div>
        );
    }
}
export default ModuleVideoListItem;


// WEBPACK FOOTER //
// ./src/componentsBody/ModuleVideoListItem.js